import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import aboutImage from "@/assets/hero-lawn-striped.jpg";

export const AboutBrian = () => {
  return (
    <section className="py-20 bg-section-alt">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full bg-secondary/10 rounded-3xl" />
              <img 
                src={aboutImage} 
                alt="Beautiful striped lawn by Riekels Lawn Care" 
                className="relative rounded-3xl w-full max-w-md mx-auto shadow-xl" 
                width={448} 
                height={448} 
                loading="lazy" 
                decoding="async" 
              />
              <div className="absolute -bottom-6 -left-6 bg-secondary text-secondary-foreground px-6 py-4 rounded-xl shadow-lg">
                <div className="text-3xl font-heading font-bold">Local</div>
                <div className="text-sm font-medium">Minnesota Business</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <span className="section-badge">Our Commitment</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground">
              We make your lawn the envy of the neighborhood.
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Riekels Lawn Care & Landscaping is the trusted choice for homeowners and business owners in the West Metro. 
              From weekly mowing to complete landscape transformations, we bring expertise and a commitment 
              to quality you can rely on.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              As a locally-owned company, our team combines hands-on experience with 
              deep knowledge of Minnesota's unique climate to deliver lawn care and landscaping solutions that 
              keep your property looking its best year-round.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link to="/contact">
                <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold">
                  Get a Free Quote <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
              <Link to="/about">
                <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold">
                  Learn More About Us
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
